import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const trainingApi = {
  getTrainingConfig: (request) => {
    // page_id
    const { config } = request
    return instance().get(`/training/cms/config`, config)
  },
  putTrainingConfig: (request) => {
    // {
    //   "page_id": "102549712095297",
    //   "max_score": "0.84",
    //   "min_score": "0.70",
    //   "auto_training": "true",
    //   "ignored": "true",
    //   "spam": "true",
    //   "ignored_setting":{
    //         "sticker": true,
    //         "location": true,
    //         "image": true,
    //         "audio": false,
    //         "video": false,
    //         "file": false
    //       }
    // }
    const { config, data } = request
    return instance().put(`/training/cms/config`, data, config)
  },
  getNonClassified: (request) => {
    // page_id
    // search
    // limit
    // offset
    const { config } = request
    return instance().get(`/training/cms/non-classified`, config)
  }
}

export default trainingApi



// WEBPACK FOOTER //
// ./src/api/training.js